import { Box } from "@mui/material";
import UserBetsComponent from "../../components/account/user-bets";
function UserBetsPage() {
  return <Box>{<UserBetsComponent />}</Box>;
}

export default UserBetsPage;
